import { Space, Text } from "@mantine/core";
import React from "react";

type EmployerImporterMatchFieldTableProps = {
  rows: string[];
};

const EmployerImporterMatchFieldTable: React.FC<
  EmployerImporterMatchFieldTableProps
> = ({ rows }) => (
  <div
    style={{
      width: "184px",
      flexGrow: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "stretch",
      padding: "0 40px 0 0",
      backgroundColor: "var(--background-background-light)",
    }}
  >
    <div
      style={{
        height: "144px",
        alignSelf: "stretch",
        flexGrow: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "stretch",
        gap: "8px",
        padding: 0,
        backgroundColor: "var(--background-background-light)",
      }}
    >
      <Text
        style={{
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: 500,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "normal",
          letterSpacing: "0.16px",
          textAlign: "left",
          color: " var(--grey-grey-80)",
        }}
      >
        Match Columns
      </Text>
    </div>
    <Space h="xl" />
    <Space h="xl" />

    <div
      style={{
        height: "40px",
        alignSelf: "stretch",
        flexGrow: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "stretch",
        gap: "8px",
        padding: "0 24px",
        borderRadius: "4px",
        backgroundColor: "var(--background-background)",
      }}
    >
      <Text
        style={{
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: 500,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "normal",
          letterSpacing: "0.16px",
          textAlign: "left",
          color: "var(--grey-grey-80)",
        }}
      >
        CSV Import
      </Text>
    </div>
    {rows.map((it) => (
      <div
        style={{
          height: "40px",
          alignSelf: "stretch",
          flexGrow: 0,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "8px",
          padding: "0 24px",
          boxShadow: "0 1px 0 0 var(--grey-grey-30)",
          backgroundColor: "var(--background-background-light)",
        }}
        key={`${it}-${Math.random()}`}
      >
        <Text
          style={{
            flexGrow: 0,
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: "normal",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "1.43",
            letterSpacing: "0.16px",
            textAlign: "left",
            color: "var(--grey-grey-80)",
          }}
        >
          {it}
        </Text>
      </div>
    ))}
  </div>
);
export default EmployerImporterMatchFieldTable;
